/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.MenuPermissionToRoleResource = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The MenuPermissionToRoleResource model module.
   * @module model/MenuPermissionToRoleResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>MenuPermissionToRoleResource</code>.
   * A resource that includes a ID of role and a ID of the menu.
   * @alias module:model/MenuPermissionToRoleResource
   * @class
   * @param roleId {String} Reqiured. The ID of the role.
   * @param menu {String} Required. The ID of the menu. such as \"overview\", \"permission\", etc.
   */
  var exports = function(roleId, menu) {
    var _this = this;

    _this['roleId'] = roleId;
    _this['menu'] = menu;
  };

  /**
   * Constructs a <code>MenuPermissionToRoleResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MenuPermissionToRoleResource} obj Optional instance to populate.
   * @return {module:model/MenuPermissionToRoleResource} The populated <code>MenuPermissionToRoleResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('roleId')) {
        obj['roleId'] = ApiClient.convertToType(data['roleId'], 'String');
      }
      if (data.hasOwnProperty('menu')) {
        obj['menu'] = ApiClient.convertToType(data['menu'], 'String');
      }
    }
    return obj;
  }

  /**
   * Reqiured. The ID of the role.
   * @member {String} roleId
   */
  exports.prototype['roleId'] = undefined;
  /**
   * Required. The ID of the menu. such as \"overview\", \"permission\", etc.
   * @member {String} menu
   */
  exports.prototype['menu'] = undefined;



  return exports;
}));



